import { useEffect, useState } from 'react';

import DocumentTraceService from '../../services/DocumentTraceService';

export const useDocumentTrace = (documentId) => {
  const [trace, setTrace] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetchedAt, setFetchedAt] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!documentId) {
      setTrace(null);
      setLoading(false);
      setError(false);
      setFetchedAt(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);
    setTrace(null);

    DocumentTraceService()
      .trace(documentId)
      .then((result) => {
        if (cancelled) return;
        setTrace(result);
        setFetchedAt(new Date());
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [documentId, reloadKey]);

  const refetch = () => {
    if (!documentId) return;
    setReloadKey((key) => key + 1);
  };

  return { trace, loading, error, fetchedAt, refetch };
};
